<template>
  <div>
    <el-row class="row-one">
      <span class="row-one-title">{{activePath}}</span>
    </el-row>
    <el-form class="form-single-inline margin-t20" :inline="true" :model="formInlieOne">
      <el-form-item>
        <el-radio-group v-model="formInlieOne.status" class="radio-single-btn1" style="margin-top: -2px;" @change="statusChange">
          <el-radio-button :label="2">全部</el-radio-button>
          <el-radio-button :label="0">未读</el-radio-button>
          <el-radio-button :label="1">已读</el-radio-button>
        </el-radio-group>
        <el-button class="margin-l10" type="delete" @click="deleteClick">删除</el-button>
        <el-button type="delete" @click="emptyClick">清空</el-button>
      </el-form-item>
    </el-form>
    <ul class="tableTit clearfix">
      <li style="width:55px;"></li>
      <li style="width:51px;">
        <img src="../../assets/images/messageCenter3.png" alt="">
      </li>
      <li style="width:150px;">类别</li>
      <li style="width:600px;">内容</li>
      <li style="min-width:90px;">时间</li>
    </ul>
    <div v-if="tableOne.length == 0 && tableTwo.length == 0" class="tableBoData">
      无数据
    </div>
    <!-- 今天 -->
    <div v-show="tableOne.length > 0">
      <p v-show="pageNum == 1" style="margin:10px 0;"><span class="aColor">今天</span>（{{listTodayNum}}封）</p>
      <el-table :data="tableOne" class="table-single today" @select="tableSingleSelected" :show-header="false">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="type" width="50">
          <template slot-scope="scope">
            <img v-if="scope.row.isRead == 1" src="../../assets/images/messageCenter1.png" alt="">
            <img v-else src="../../assets/images/messageCenter2.png" alt="">
          </template>
        </el-table-column>
        <el-table-column label="类别" prop="type" width="150"></el-table-column>
        <el-table-column label="内容" prop="Summary" width="600">
          <template slot-scope="scope">
            <div :class="[{'ov':!scope.row.toggle}]" style="text-align:left;">
              <span style="font-weight:bold;">{{scope.row.AddDate}} - </span>
              <span>{{scope.row.Summary}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="addTime">
          <template slot-scope="scope">
            <span>{{scope.row.addTime}}</span>
            <i :class="['el-icon-arrow-down','spread',{'messageOpen':scope.row.toggle}]" @click="spreadClick(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 今天之前 -->
    <div v-show="tableTwo.length > 0">
      <p v-show=" (listTodayNum == 0 && pageNum == 1) ||(pageNum == 2 && listTodayNum == 10) || Math.ceil(tableOne.length / 10)" style="margin:10px 0;"><span class="aColor">今天之前</span>（{{listFrontNum}}封）</p>
      <el-table :data="tableTwo" class="table-single today" @select="tableTwoSelected" :show-header="false">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="type" width="50">
          <template slot-scope="scope">
            <img v-if="scope.row.isRead == 1" src="../../assets/images/messageCenter1.png" alt="">
            <img v-else src="../../assets/images/messageCenter2.png" alt="">
          </template>
        </el-table-column>
        <el-table-column label="类别" prop="type" width="150"></el-table-column>
        <el-table-column label="内容" prop="Summary" width="600">
          <template slot-scope="scope">
            <div :class="[{'ov':!scope.row.toggle}]" style="text-align:left;">
              <span style="font-weight:bold;">{{scope.row.AddDate}} - </span>
              <span>{{scope.row.Summary}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="addTime">
          <template slot-scope="scope">
            <span>{{scope.row.addTime}}</span>
            <i :class="['el-icon-arrow-down','spread',{'messageOpen':scope.row.toggle}]" @click="spreadClick(scope.row)"></i>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <!-- 页码 -->
    <el-pagination class="pagination-single" @size-change="handleSizeChangeOne" @current-change="handleCurrentChangeOne" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page>
    </el-pagination>
  </div>
</template>


<script>
export default {
  props: ["activePath"],
  name: "messaeCon",
  data () {
    return {
      formInlieOne: {
        status: 2,
      },
      status: 2,
      tableOne: [],
      tableTwo: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      type: '',
      //   数组
      deleteArr: [],
      listFrontNum: '',
      listTodayNum: '',
      // 删除
      deleteOne: [],
      deleteTwo: [],
    }
  },
  mounted () {
    this.type = this.activePath
    this.getmessageLists()
  },
  methods: {
    // 获取消息列表
    getmessageLists (pageNum, pageSize) {
      this.$http.post(this.$apiPath.getPushListPC, {
        type: this.type,
        custno: this.$commonJs.getCookie('u_custno1'),
        page: pageSize || this.pageSize || 10,
        pageInt: (pageNum || this.pageNum || 1) - 1,
        status: this.status,
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          res.data.data.listToday.forEach(item => {
            item.toggle = false
          });
          res.data.data.listFront.forEach(item => {
            item.toggle = false
          });
          this.tableOne = res.data.data.listToday
          this.tableTwo = res.data.data.listFront
          this.total = res.data.data.listTodayNum + res.data.data.listFrontNum
          this.listFrontNum = res.data.data.listFrontNum
          this.listTodayNum = res.data.data.listTodayNum
        }
      }).catch(err => { })
    },
    handleSizeChangeOne (newSize) {
      this.pageNum = 1;
      this.pageSize = newSize
      this.getmessageLists(this.pageNum, newSize)
    },
    handleCurrentChangeOne (newPage) {
      this.loadingOne = true
      this.pageNum = newPage
      this.getmessageLists(newPage, this.pageSize)
    },
    // 切换状态
    statusChange (val) {
      this.status = val
      this.getmessageLists()
    },
    // 展开
    spreadClick (val) {
      val.isRead = 1
      val.toggle = !val.toggle
      this.messageHandle('0', val.id)
    },
    // 阅读，删除 flag（0-阅读，1-删除）
    messageHandle (flag, id) {
      this.$http.post(this.$apiPath.updatePushNumPC, {
        flag: flag,
        custno: this.$commonJs.getCookie('u_custno1'),
        ID: id,
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200" && res.data.message == "成功") {
          if (flag == 1) {
            this.$message.success("删除成功")
            this.getmessageLists()
            this.deleteArr = []
          }
        } else {
          this.$message.error("删除失败")
        }
      }).catch(err => { })
    },
    // 选中删除
    tableSingleSelected (arr) {
      this.deleteOne = arr
    },
    tableTwoSelected (arr) {
      this.deleteTwo = arr
    },
    // 删除
    deleteClick () {
      this.deleteArr = this.deleteOne.concat(this.deleteTwo);
      if (this.deleteArr.length > 0) {
        for (var i = 0; i < this.deleteArr.length; i++) {
          this.messageHandle('1', this.deleteArr[i].id)
        }
      } else {
        this.$message.error('请选择要删除的内容！')
      }
    },
    // 清空   flag(0-未读，1-已读,2-全部),
    emptyClick () {
      let status = ''
      if (this.status == 2) {
        status = '全部'
      } else if (this.status == 0) {
        status = '未读'
      } else {
        status = '已读'
      }
      this.$confirm('此操作将清空【' + this.type + '】' + status + '信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(this.$apiPath.clearMessagePush, {
          flag: this.status,
          custno: this.$commonJs.getCookie('u_custno1'),
          noti: this.type
        }).then(res => {
          // console.log(res);
          if (res.data.code == "200" && res.data.message == "成功") {
            this.$message.success('清空消息成功')
            this.getmessageLists()
            this.$emit('emptyAll')
          } else {
            this.$message.error('清空消息失败')

          }
        }).catch(err => { })
      }).catch(() => { });
    }
  },
  watch: {
    activePath: function (val) {
      this.type = val
      this.getmessageLists()
    }
  }
}
</script>

<style lang="less">
.spread {
  margin-left: 10px;
  cursor: pointer;
  transition: all 1s;
  transform: rotate(0deg);
}
.messageOpen {
  transition: all 1s;
  transform: rotate(180deg);
}
.ov {
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 返回 */
.el-button--delete:focus,
.el-button--delete:hover {
  border-color: @colorC3;
  background-color: @wColor;
  color: @color;
}
.el-button--delete {
  min-width: 70px;
  padding: 8px 13px;
  border-color: @colorC3;
  background-color: @wColor;
  font-size: 14px;
  color: @color;
  border-radius: 0;
}
// 表头
.tableTit {
  height: 33px;
  line-height: 33px;
  background: @color;
  color: @wColor;
  li {
    float: left;
    height: 100%;
    text-align: center;
    font-weight: bold;
  }
}
.today {
  .el-table__body-wrapper table {
    border-top: 1px solid @colorE5!important;
  }
}
.today::before {
  content: "";
  width: 1px;
  height: 100%;
  background: @colorE5;
  position: absolute;
  top: 0;
  left: auto;
  right: 0;
  z-index: 10;
}
// 无数据
.tableBoData {
  width: calc(100% -2px);
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: @color9;
  border: 1px solid @colorE5;
}
</style>